'use client';
import e__default from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PriceBarCouponCallout = renderWithRef('PriceBarCouponCallout`', null, (e, t)=>{
    let { children: a } = e, c = new Set([
        'swan-price-bar-coupon-callout'
    ]);
    return e__default.createElement(RenderComp, {
        root: "div",
        forwardedRef: t,
        classNames: c,
        props: e
    }, a);
});

export { PriceBarCouponCallout };
